import {
  DeleteOutlined,
  EditOutlined,
  EllipsisOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Col, Drawer, Dropdown, Modal, Table, Tag, Typography } from "antd";
import { FC, useEffect, useState } from "react";
import { deletePortfolioUserByStore } from "../Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useQueryClient } from "react-query";
import endPoints from "../EndPoints";
import { ItemType } from "antd/es/menu/interface";
import AddOrUpdateUser from "./AddOrUpdate/AddOrUpdateUser";
import { MazakaBull } from "apps/Common/MazakaBull";

const UserShoppingList: FC<{ data: any }> = ({ data }) => {
  const [isShowEditDrawer, setIsShowEditDrawer] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any | null>(null);
  const queryClient = useQueryClient();
  const { Text } = Typography;
  const columns = [
    {
      title: "Mağaza",
      render: (text: string, record: any) => {
        return (
          <>
            <Text>{record?.store?.storeName || ""}</Text>
          </>
        );
      },
    },

    {
      title: "Davet Durumu",
      dataIndex: "invitationStatus",
      key: "invitationStatus",
      render: (status: number) => (
        <Tag
          color={`${status === 0 ? "blue" : status === 1 ? "green" : "error"}`}
        >{`${
          status === 0
            ? "Onay Bekliyor"
            : status === 1
            ? "Kabul Edildi"
            : "Reddedildi"
        }`}</Tag>
      ),
    },

    {
      title: "İlan Verebilir Mi",
      dataIndex: "isAuthPostAdvert",
      key: "isAuthPostAdvert",
      render: (status: boolean) => (
        <MazakaBull type={status ? "Success" : "Error"} />
      ),
    },
    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: "8%",
      render: (key: any, record: any) => (
        <Col className="text-end pr-2">
          <Dropdown menu={{ items: tableItemDropdownMenu(record) }}>
            <EllipsisOutlined className="text-xl" />
          </Dropdown>
        </Col>
      ),
    },
  ];
  const tableItemDropdownMenu = (record: any): ItemType[] => {
    return [
      {
        key: "1",
        onClick: async () => {
          await setSelectedRecord(record);
          setIsShowEditDrawer(true);
        },
        icon: <EditOutlined />,
        label: "Güncelle",
      },
      {
        key: "2",
        onClick: () => {
          confirm(record);
        },
        icon: <DeleteOutlined />,
        label: "Sil",
      },
    ];
  };

  const confirm = (record: any) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu öğe silinecek. Onaylıyor musunuz?`,
      okText: "Sil",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          const deleteStoreFromUser = {
            userId: data.id,
            storeId: record.storeId,
          };

          await deletePortfolioUserByStore(deleteStoreFromUser);
          openNotificationWithIcon("default", "İşlem Başarılı");

          const userData = { ...portfolioUserData };

          const filteredStoreData = userData?.storePortfolioUser?.filter(
            (item: any) => item.storeId !== record?.storeId
          );
          userData["storePortfolioUser"] = filteredStoreData;
          setPortfolioUserData(userData);
          queryClient.resetQueries({
            queryKey: endPoints.getPortfolioUserByStoreFilter,
            exact: false,
          });
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };

  const [portfolioUserData, setPortfolioUserData] = useState<any>(null);

  useEffect(() => {
    setPortfolioUserData(data);
  }, [data?.storePortfolioUser]);

  return (
    <>
      <Table
        columns={columns}
        rowKey={"id"}
        dataSource={portfolioUserData?.storePortfolioUser || []}
        pagination={{
          position: ["bottomRight"],
          className: "!px-0",

          total: data?.length || 0,
          pageSize: 20,
          showLessItems: true,
          size: "small",
          showSizeChanger: true,
          locale: { items_per_page: "" },
          showTotal: (e) => `${e}`,
        }}
      />
      <Drawer
        open={isShowEditDrawer}
        onClose={() => {
          setIsShowEditDrawer(false);
        }}
      >
        <AddOrUpdateUser
          selectedRecord={{
            ...selectedRecord,
            name: portfolioUserData?.name,
            surname: portfolioUserData?.surname,
            eMail: portfolioUserData?.eMail,
            phoneNumber: portfolioUserData?.phoneNumber,
            numberPrefix: portfolioUserData?.numberPrefix,
            profileName: portfolioUserData?.profileName,
            profilPicture: portfolioUserData?.profilPicture,
          }}
          type="edit-single-record"
          onFinish={() => {
            queryClient.resetQueries({
              queryKey: endPoints.getPortfolioUserByStoreFilter,
              exact: false,
            });
            setIsShowEditDrawer(false);
          }}
        />
      </Drawer>
    </>
  );
};

export default UserShoppingList;
